import React, { useEffect, useRef, useState } from 'react'
import { NavLink } from '../../../lib/Navigation'
import { Swiper } from 'antd-mobile'
import Trade from '../Trade'
import ActiveContext from '../../../lib/ActiveContext'
import Submit from '../Submit'
import Recovery from '../../recovery/Index'
import RecoveryRecord from '../../recovery/Record'
import TradeRecode from '../Record'
import FavoriteTrade from '../../user/game/FavoriteTrade'
import useActiveState from '../../../lib/useActiveState'
import general from '../../../general'
import Dialog from '../../../lib/Dialog'
import Manager from '../../components/Manager'
import { useLocation } from 'react-router-dom';

const actions = [
  {
    title:'买号',
    component:Trade,
    event_id:'A-4-8'
  },
  {
    title:'卖号',
    component:Submit,
    event_id:'A-4-2'
  },
  {
    title:'回收',
    component:Recovery,
    event_id:'A-4-3'
  },
  {
    title:'记录',
    component:TradeRecode,
    event_id:'A-4-4'
  },
  {
    title:'收藏',
    component:FavoriteTrade,
    event_id:'A-4-9'
  },
]

export default function TradeIndex(props) {

  const [index,setIndex] = useState(0)
  const swiperRef = useRef()
  const [user] = useActiveState('user')

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get('id');

  useEffect(()=>{
    if (props.active && id) {
      setIndex(id);
    }
  },[props.active,id])
  
  return (
    <div>
      <div className='trade-home'>
        <div className="trade-navbar">
          <div className="navs">
            {actions.map((action,idx) => {
              return (
                <NavLink user={idx == 0 ? false : true} onClick={()=>{
                  Manager.push({event_id:action.event_id})
                  if (!user.mobile && (idx == 1 || idx == 2)) {
                    Dialog.confirm({
                      title: '没有绑定手机号，现在去绑定？',
                      yes: () => {
                        general.history.push('/user/phone');
                      }
                    });
                    return
                  }
                  setIndex(idx)
                  // swiperRef.current.swipeTo(idx)
                }} className={'nav-item ' + (index == idx ? 'active' : '')}>{action.title}</NavLink>
              )
            })}
          </div>
          <div>
            <NavLink onClick={()=>{
              Manager.push({event_id:'A-4-10'})
            }} user={false} className="service" to="/service">
              <img className="icon" src="resources/250410/service.png" alt="" />
            </NavLink>
            <NavLink onClick={()=>{
              Manager.push({event_id:'A-4-5'})
            }} user={false} activeColor={'#ffffff'} className="service" to="/trade/notice">
              <img className="icon" src="resources/250410/trade-notice.png" alt="" />
            </NavLink>
          </div>
          </div>
        <div>
          {actions.map((action,idx) => {
              return (
                <div className='body-item' style={{display:(index == idx ? '' : 'none')}}>
                  <div className="container">
                  <ActiveContext.Provider>
                    <action.component active={index == idx && props.active} id={''}/>
                  </ActiveContext.Provider>
                  </div>
                </div>
              )
            })}
          {/* <Swiper indicator={() => null} ref={swiperRef} onIndexChange={idx=>setIndex(idx)}>
            {actions.map((action,idx) => {
              return (
                <Swiper.Item className='body-item'>
                  <div className="container">
                  <ActiveContext.Provider>
                    <action.component active={index == idx} id={''}/>
                  </ActiveContext.Provider>
                  </div>
                  
                </Swiper.Item>
              )
            })}
          </Swiper> */}
        </div>
      </div>
    </div>
  )
}
